import { createSelector } from 'reselect';
import { getEntityByName } from '../../../appEntities';
import { RESELLER_WIDGET_SETTINGS_UPDATE } from './resellerWidgetSettingsActions';

const initialState = { currencyId: '840', currencyCode: 'USD' };

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RESELLER_WIDGET_SETTINGS_UPDATE:
            return {
                ...state,
                currencyId: action.payload.currencyId,
                currencyCode: action.payload.currencyCode
            };
        default:
            return state;
    }
}

export const getResellerWidgetSettingsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'resellerWidgetSettings')
);
